import { render } from "./socialMediaComponent.vue?vue&type=template&id=81fb6bf4&scoped=true&ts=true"
import script from "./socialMediaComponent.vue?vue&type=script&lang=ts"
export * from "./socialMediaComponent.vue?vue&type=script&lang=ts"

import "./socialMediaComponent.vue?vue&type=style&index=0&id=81fb6bf4&scoped=true&lang=scss"

import exportComponent from "D:\\J\\workspace\\FusionServer\\QUA\\Manitou.FusionServer.Web.DiagPortalFront\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81fb6bf4"]])

export default __exports__